import { useMemo } from 'react';
import { getContractById } from './contractHelper';
import { useContracts } from './useContracts';

export const useContract = (contractId = '') => {
  const { contracts } = useContracts();
  return useMemo(() => {
    return getContractById(contractId, contracts);
  }, [contractId, contracts]);
};
